export const Action = {
  GET_DEVICES: "GET_DEVICES",
  GET_DEVICE: "GET_DEVICE",
};

export const Mutation = {
  GET_DEVICES: "GET_DEVICES",
  GET_DEVICE: "GET_DEVICE",
};

export const Getter = {
  DEVICES: "DEVICES",
  DEVICE: "DEVICE",
  SCHEDULES: "SCHEDULES",
};
